import Model from "braindamage/model";
import BirlExerciseSchema from 'generated/schemas/birl/exercise'

class BirlExercise extends Model {
  static schema = BirlExerciseSchema;
  static modelName = 'BirlExercise';

  // Fill-in your attribute overrides
  static attributesDefinitions() {
    return {};
  }

  withZerosWeightMap() {
    return this.weightMap.map((weightMapItem) => {
      if(!weightMapItem.weight)
        weightMapItem.weight = 0
      return weightMapItem;
    })
  }
}

export default BirlExercise.define();
